import { render, staticRenderFns } from "./buyHp.vue?vue&type=template&id=964ee3fa&scoped=true"
import script from "./buyHp.vue?vue&type=script&lang=js"
export * from "./buyHp.vue?vue&type=script&lang=js"
import style0 from "./buyHp.vue?vue&type=style&index=0&id=964ee3fa&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "964ee3fa",
  null
  
)

export default component.exports